import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    width: "100%",
  },
  description: {
    marginTop: 24,
    display: "block",
    [theme.breakpoints.down("desktop")]: {
      fontSize: theme.fontSizes.md,
      marginTop: 8,
    },
  },

  currentPercentage: {
    fontWeight: "bold",
  },
  snackbar_container: {
    left: "45%",
    top: "100px",
    position: "fixed",
    zIndex: 100,
  },
  tabsContainer: {
    marginTop: 28,
    [theme.breakpoints.down("desktop")]: {
      marginTop: 12,
    },
  },

  stepTwo_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
  },

  mobile_stepTwo_container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
    padding: "0px 20px",
  },

  title_container: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "40px",
    marginBottom: "32px",
    width: "100%",
    fontSize: "35px",
  },

  mobile_title_container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "20px",
    fontWeight: "bold",
    marginTop: "20px",
    fontSize: "26px",
  },

  underlineNav_container: {
    marginTop: "10px",
  },

  secondRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "40px",
  },

  mobile_secondRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginBottom: "31px",
    flexDirection: "column",
  },

  links: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "270px",
    marginTop: "17px",
  },

  graph_container: {
    width: "100%",
    minHeight: 200,
    marginBottom: "64px",
  },

  mobile_graph_container: {
    width: "100%",
    minHeight: 200,
    marginBottom: "30px",
  },

  wideTable_container: {
    width: "100%",
  },
}));

export default useStyles;
